export default __webpack_public_path__ + "static/media/girlReadingColoured.2f1cb512.png";